import robotPhoto from "../../Assets/Images/robot_operation.jpeg";
import bhuhitAgriDashboad from "../../Assets/Images/Bhuhit_AgriDashboard.jpeg";
import bhuhitEOVideoMarathi from "../../Assets/Videos/Bhuhit_EO_Video_Marathi.mp4";
import bhuhitEOVideoHindi from "../../Assets/Videos/Bhuhit_EO_Video_Hindi.mp4";
import bhuhitNCO from "../../Assets/Videos/Bhuhit_N_Cloud_Operation.mp4";
import bhuhitNRO from "../../Assets/Videos/Bhuhit_N_Remote_Operation.mp4";
// Our own recorded voice, one mp3 per language, in src/Assets/Audio/
import voiceEnglish from "../../Assets/Audio/Bhuhit_Voice_English.mp3";
import voiceMarathi from "../../Assets/Audio/Bhuhit_Voice_Marathi.mp3";
import voiceHindi from "../../Assets/Audio/Bhuhit_Voice_Hindi.mp3";

// Videos and photos shown on the home page.
// Put video files in  public/videos/  and photos in  public/images/,
// then add one line per file here (src starts with /videos/ or /images/).
export const MEDIA = [
    { type: "video", src: bhuhitEOVideoMarathi, title: "Bhuhit Agri Earth Observation" },
    { type: "video", src: bhuhitEOVideoHindi, title: "Bhuhit Agri Earth Observation" },
    { type: "video", src: bhuhitNCO, title: "Bhuhit Cloud Robot Operation" },
    { type: "video", src: bhuhitNRO, title: "Bhuhit Remote Robot Operation" },
    //{ type: "video", src: "/Videos/Bhuhit N Remote Operation1.mp4", title: "Bhuhit Remote Robot Operation" },
    { type: "image", src: robotPhoto, title: "Bhuhit Agri Robot spraying in the field" },
    { type: "image", src: bhuhitAgriDashboad, title: "Bhuhit Agri Dashboard: Farm Monitoring from Satellite Data" },
    // { type: "video", src: "/videos/grass-cutting.mp4", title: "Grass cutting" },
    // { type: "image", src: "/images/sowing.jpg", title: "Sowing" },
];

// To add a language, add one entry here (audio = recorded mp3 voice file)
export const LANGS = {
    en: {
        label: "English", audio: voiceEnglish,
        headline: "See your farm from anywhere. Operate Bhuhit robots from anywhere.",
        sub: "Cloud-monitored and cloud-controlled robots for grass cutting, spraying and sowing, accessible from any device.",
        operate: "Robot Operation", watch: "Watch video", listen: "Listen", stop: "Stop", gallery: "Videos & photos",
        pillarsTitle: "One cloud platform",
        pillars: [
            ["Operation", "Run one robot or many from the cloud."],
            ["Monitoring", "Live view of robots and farms."],
            ["Reporting", "Reports to measure efficacy."],
            ["Analytics", "Insights from robot data."],
        ],
        worksTitle: "Our work: Robot for Welfare of Soil",
        works: [
            ["Agri Robot", "Grass cutting, spraying, sowing and harvesting with the Bhuhit Agri Robot."],
            ["SunVeg Dryer", "Drying of farm produce with the SunVeg Dryer."],
            ["Bhu-Up", "Natural weed control and soil care for healthier, organic farming."],
            //["AI crop and herb detection", "AI on the Bhuhit Agri Robot recognises herbs and crops in the field."],
            //["Satellite Agri Dashboard", "Crop health, soil moisture, soil temperature and forecasts from satellite data."],
            ["Remote Robot Operation", "Operate your Bhuhit robots from anywhere, without being on the farm."],
            ["Cloud Operation & Analytics", "Operate, monitor and report on many robots from one cloud platform."],
            ["Business Intelligence & Dashboards", "Track robot operations, performance and farm activity through clear dashboards."],
        ],
        instTitle: "Robots Built for Farmers",
        farmersText: "Monitor your robots from anywhere, operate them remotely and get clear reports.",
        inst: [
            ["Field-level GPS maps", "Every farm is mapped and configured, ready for planning and review."],
            ["Reports and analytics", "Operation reports to measure results and efficacy."],
            ["Remote monitoring", "Watch robots and farms from anywhere, and take over with a joystick when needed."],
        ],
        ctaTitle: "Start with Bhuhit",
        ctaText: "Open Robot Operation to run your robots and see your farms.",
    },
    mr: {
        label: "मराठी", audio: voiceMarathi,
        headline: "तुमची शेती कुठूनही पाहा. भूहित रोबोट कुठूनही चालवा.",
        sub: "गवत कापणी, फवारणी आणि पेरणीसाठी क्लाउडवरून निरीक्षण व नियंत्रण करता येणारे रोबोट, कोणत्याही डिव्हाइसवरून.",
        operate: "रोबोट संचालन", watch: "व्हिडिओ पाहा", listen: "ऐका", stop: "थांबवा", gallery: "व्हिडिओ आणि फोटो",
        pillarsTitle: "एकच क्लाउड व्यासपीठ",
        pillars: [
            ["संचालन", "एक किंवा अनेक रोबोट क्लाउडवरून चालवा."],
            ["निरीक्षण", "रोबोट आणि शेतांचे थेट दर्शन."],
            ["अहवाल", "परिणामकारकता मोजण्यासाठी अहवाल."],
            ["विश्लेषण", "रोबोटच्या माहितीतून अंतर्दृष्टी."],
        ],
        worksTitle: "आमचे कार्य: Robot for Welfare of Soil",
        works: [
            ["कृषी रोबोट", "भूहित कृषी रोबोटद्वारे गवत कापणी, फवारणी, पेरणी आणि काढणी."],
            ["सनव्हेज ड्रायर", "सनव्हेज ड्रायरने शेतमाल वाळवणे."],
            ["भू-अप", "आरोग्यदायी सेंद्रिय शेतीसाठी नैसर्गिक तण नियंत्रण आणि मातीची निगा."],
            //["एआय पीक व वनस्पती ओळख", "भूहित कृषी रोबोटवरील एआय शेतातील औषधी वनस्पती व पिके ओळखते."],
            //["उपग्रह कृषी डॅशबोर्ड", "उपग्रह माहितीवरून पीक आरोग्य, मातीतील ओलावा, मातीचे तापमान आणि अंदाज."],
            ["रिमोट रोबोट संचालन", "तुमचे भूहित रोबोट शेतावर न जाता, कुठूनही चालवा."],
            ["क्लाउड संचालन व विश्लेषण", "एकाच क्लाउड व्यासपीठावरून अनेक रोबोटचे संचालन, निरीक्षण व अहवाल."],
            ["बिझनेस इंटेलिजन्स व डॅशबोर्ड", "रोबोटचे कामकाज, कामगिरी आणि शेतातील कामांचा मागोवा स्पष्ट डॅशबोर्डद्वारे घ्या."],
        ],
        instTitle: "शेतकऱ्यांसाठी बनवलेले रोबोट",
        farmersText: "तुमच्या रोबोटवर कुठूनही लक्ष ठेवा, त्यांना दुरून चालवा आणि स्पष्ट अहवाल मिळवा.",
        inst: [
            ["शेत-स्तरीय GPS नकाशे", "प्रत्येक शेताचा नकाशा तयार करून तो कॉन्फिगर केलेला आहे, नियोजन आणि आढाव्यासाठी सज्ज."],
            ["अहवाल व विश्लेषण", "निकाल आणि परिणामकारकता मोजण्यासाठी संचालन अहवाल."],
            ["दुरून देखरेख", "कुठूनही रोबोट आणि शेतांवर लक्ष ठेवा, आणि गरज पडल्यास जॉयस्टिकने नियंत्रण स्वतःच्या हाती घ्या."],
        ],
        ctaTitle: "भूहितसोबत सुरुवात करा",
        ctaText: "तुमचे रोबोट चालवण्यासाठी आणि शेते पाहण्यासाठी रोबोट संचालन उघडा.",
    },
    hi: {
        label: "हिन्दी", audio: voiceHindi,
        headline: "अपना खेत कहीं से भी देखें। भूहित रोबोट कहीं से भी चलाएँ।",
        sub: "घास कटाई, छिड़काव और बुवाई के लिए क्लाउड से निगरानी और नियंत्रण किए जा सकने वाले रोबोट, किसी भी डिवाइस से।",
        operate: "रोबोट संचालन", watch: "वीडियो देखें", listen: "सुनें", stop: "रोकें", gallery: "वीडियो और फोटो",
        pillarsTitle: "एक क्लाउड प्लेटफ़ॉर्म",
        pillars: [
            ["संचालन", "एक या कई रोबोट क्लाउड से चलाएँ।"],
            ["निगरानी", "रोबोट और खेतों का लाइव दृश्य।"],
            ["रिपोर्ट", "प्रभावशीलता मापने के लिए रिपोर्ट।"],
            ["विश्लेषण", "रोबोट के डेटा से जानकारी।"],
        ],
        worksTitle: "हमारा काम: Robot for Welfare of Soil",
        works: [
            ["कृषि रोबोट", "भूहित कृषि रोबोट से घास कटाई, छिड़काव, बुवाई और कटाई।"],
            ["सनवेज ड्रायर", "सनवेज ड्रायर से कृषि उपज को सुखाना।"],
            ["भू-अप", "स्वस्थ जैविक खेती के लिए प्राकृतिक खरपतवार नियंत्रण और मिट्टी की देखभाल।"],
            //["एआई फसल व जड़ी-बूटी पहचान", "भूहित कृषि रोबोट पर लगा एआई खेत में जड़ी-बूटियों और फसलों की पहचान करता है।"],
            //["सैटेलाइट कृषि डैशबोर्ड", "सैटेलाइट डेटा से फसल की सेहत, मिट्टी की नमी, मिट्टी का तापमान और पूर्वानुमान।"],
            ["रिमोट रोबोट संचालन", "अपने भूहित रोबोट को कहीं से भी चलाएँ, खेत पर मौजूद होने की ज़रूरत नहीं।"],
            ["क्लाउड संचालन और विश्लेषण", "एक ही क्लाउड प्लेटफ़ॉर्म से कई रोबोट का संचालन, निगरानी और रिपोर्टिंग।"],
            ["बिज़नेस इंटेलिजेंस और डैशबोर्ड", "रोबोट के संचालन, प्रदर्शन और खेत की गतिविधियों को स्पष्ट डैशबोर्ड से ट्रैक करें।"],
        ],
        instTitle: "किसानों के लिए बने रोबोट",
        farmersText: "अपने रोबोट की निगरानी कहीं से भी करें, उन्हें दूर से चलाएँ और स्पष्ट रिपोर्ट पाएँ।",
        inst: [
            ["खेत-स्तर के GPS नक्शे", "हर खेत का नक्शा बनाकर उसे कॉन्फ़िगर किया गया है, जो योजना और समीक्षा के लिए तैयार है।"],
            ["रिपोर्ट और विश्लेषण", "परिणाम और प्रभावशीलता मापने के लिए संचालन रिपोर्ट।"],
            ["दूर से निगरानी", "कहीं से भी रोबोट और खेतों पर नज़र रखें, और ज़रूरत पड़ने पर जॉयस्टिक से नियंत्रण अपने हाथ में लें।"],
        ],
        ctaTitle: "भूहित के साथ शुरू करें",
        ctaText: "अपने रोबोट चलाने और खेत देखने के लिए रोबोट संचालन खोलें।",
    },
};

export const PILLAR_ICONS = ["fa-play-circle", "fa-eye", "fa-file-text-o", "fa-area-chart"];
export const WORK_ICONS = ["fa-cogs", "fa-sun-o", "fa-leaf", "fa-eye", "fa-globe", "fa-dashboard"];
// Three items now, so the third icon is the remote-monitoring one (was fa-language)
export const INST_ICONS = ["fa-map-marker", "fa-file-text-o", "fa-desktop"];